export var zendeskScriptUrl = "https://static.zdassets.com/ekr/snippet.js?key=50e6e8cb-4c25-46f4-a4bb-2a031989284d";
export var zendeskMessengerScriptProps = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ze-snippet";
    return {
        id: id,
        src: zendeskScriptUrl,
        "data-testid": id
    };
};
